// Lib
import React from 'react';
import styled from 'styled-components';

// Theme
import colors from 'theme/colors';

// Hooks
import useDropDownHandlers from 'hooks/useDropDownHandlers';

// Components
import Icon from 'components/Icon';
import DropDownItemWrapper from './DropDownItemWrapper';
import DropDownItemName from './DropDownItemName';

const DropDownItemIcon = styled(Icon)`
  margin-right: 20px;
`;

const DropDownItemNested = styled.div<any>`
  background: ${colors.white};
  border: 2px solid ${colors.gray};
  bottom: ${props => (props.isBottom ? '0' : 'auto')};
  visibility: hidden;
  position: absolute;
  top: ${props => (props.isBottom ? 'auto' : '0')};
  width: 100%;
  left: ${props => !props.isLeftSide && '100%'};
  right: ${props => props.isLeftSide && '100%'};
`;

interface DropDownItemProps {
  name: string;
  onClick?: VoidFunction;
  icon?: string;
  children?: any;
  disabled?: boolean;
  isLeftSide?: boolean;
  padding?: string;
}

const DropDownItem: React.FC<DropDownItemProps> = (props): JSX.Element => {
  const { name, onClick, icon, children, disabled, isLeftSide, padding } = props;
  const { node, isCloseToBottom } = useDropDownHandlers();

  return (
    <DropDownItemWrapper
      onClick={!disabled ? onClick : undefined}
      disabled={disabled}
      padding={padding}
    >
      {icon && <DropDownItemIcon type={icon} />}
      <DropDownItemName>{name}</DropDownItemName>
      {children && (
        <DropDownItemNested
          className="DropDown__nested"
          isLeftSide={isLeftSide}
          ref={node}
          isBottom={isCloseToBottom}
        >
          {children}
        </DropDownItemNested>
      )}
    </DropDownItemWrapper>
  );
};

DropDownItem.defaultProps = {
  disabled: false,
  isLeftSide: false,
};

export default DropDownItem;
